import { useState } from 'react';
import { useNavigate } from 'react-router';
import { X } from 'lucide-react';

import { useAuth } from '../../contexts/AuthContext';
import { useAppearance } from '../../contexts/AppearanceContext';
import { cn } from '../../lib/utils';

function bannerDismissKey(uid: string) {
  return `lexgat_profile_banner_dismissed_${uid}`;
}

export default function ProfileCompleteBanner() {
  const { user, userData } = useAuth();
  const { isGlass } = useAppearance();
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(() => {
    if (!user?.uid) return false;
    return sessionStorage.getItem(bannerDismissKey(user.uid)) === '1';
  });

  const loginCount = userData?.loginCount ?? 0;
  const show =
    Boolean(user?.uid) &&
    userData?.onboarded === true &&
    userData?.profileComplete === false &&
    loginCount >= 5 &&
    !dismissed;

  if (!show) return null;

  const handleDismiss = () => {
    if (user?.uid) {
      sessionStorage.setItem(bannerDismissKey(user.uid), '1');
    }
    setDismissed(true);
  };

  return (
    <div className="app-shell-inset relative z-[44] mb-2 shrink-0">
      <div className="mx-auto w-full max-w-[42rem]">
      <div
        className={cn(
          'w-full px-4 py-2.5',
          'rounded-2xl border',
          'flex flex-col sm:flex-row sm:items-center gap-2.5 sm:gap-3',
          'shadow-[0_8px_30px_-6px_rgba(0,0,0,0.12),0_2px_8px_-2px_rgba(0,0,0,0.06)]',
          isGlass
            ? 'bg-white/75 backdrop-blur-xl border-white/70'
            : 'bg-white/95 backdrop-blur-sm border-slate-200/70',
        )}
        role="status"
      >
        <p className="text-sm font-medium text-text-main flex-1 text-center sm:text-left">
          Please complete your profile
        </p>
        <div className="flex items-center justify-center sm:justify-end gap-1.5 shrink-0">
          <button
            type="button"
            onClick={() => navigate('/complete-profile')}
            className="btn-primary !rounded-full px-3.5 py-1.5 text-xs"
          >
            Complete profile
          </button>
          <button
            type="button"
            onClick={handleDismiss}
            className="p-1.5 rounded-full text-text-muted hover:text-text-main hover:bg-slate-100/80 transition-colors"
            aria-label="Dismiss"
          >
            <X className="w-3.5 h-3.5" />
          </button>
        </div>
      </div>
    </div>
    </div>
  );
}
